import { useRequest } from '../providers/useRequest';

import AppError from '../../errors/AppError';
import ICalculationDate from '../../interfaces/ICalculationDate';

const useCalculationDate = () => {
  const calculationDate = useRequest<ICalculationDate[]>();
  const path = 'point-control';

  let storage = sessionStorage.getItem('user');

  if (!storage) {
    storage = localStorage.getItem('localSettings');
  }

  const data = JSON.parse(storage ?? '');

  const tenantDomain = data.tenantDomain.replace('.', '_').replace('.', '_');

  const listCalculationDate = async (employeeId: number | undefined): Promise<any> => {
    return await calculationDate
      .getOne({
        path: `${path}/calculation-date/${employeeId}`,
        sendAuthorization: false,
        headers: { tenantDomain: tenantDomain },
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };
  const listWithSearch = async (employeeId: number, limit: number, orderDirection: string): Promise<any> => {
    return await calculationDate
      .getOne({
        path: `${path}/calculation-date/${employeeId}?limit=${limit}&orderDirection=${orderDirection}`,
        sendAuthorization: false,
        headers: { tenantDomain: tenantDomain },
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };
  const findCalculationDateByDate = async (companyId: number | undefined, date: string): Promise<any> => {
    return await calculationDate
      .getOne({
        path: `${path}/find-calculation-date/${companyId}/${date}`,
        sendAuthorization: false,
        headers: { tenantDomain: tenantDomain },
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  return { listCalculationDate, findCalculationDateByDate, listWithSearch };
};

export { useCalculationDate };
